module.exports = __webpack_public_path__ + "media/_archive/7-b9d0cecd.png";